import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/styles.css'; // Estilos globales
import './styles/variables.css'; // Variables CSS

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// Registro del service worker para la PWA
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
       navigator.serviceWorker.register('/sw.js')
            /*.then(registration => {
                console.log('Service Worker registrado con éxito:', registration);
            })*/
            .catch(error => {
                console.log('Error al registrar el Service Worker:', error);
            });
    });
}
